import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { makeFetchedObjectI18nLabel, makeEnrolledObjectI18nLabel } from 'automation-ui-formula-editor/data-sources/utils/makeI18nLabelUtils';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';

/**
 * Resolve the action output label on the FE. BE currently has no way of resolving the action number
 * that gets displayed to the user, which is different than the actionId
 */
export const mutateActionOutputDefinitionData = (dataFromAPI, mutators) => {
  const {
    getActionHeaderTitle
  } = mutators;
  const metadata = dataFromAPI.dataSourceDefinition.metadata;
  const {
    actionId
  } = metadata;
  const label = getActionHeaderTitle({
    actionId,
    useString: true
  });

  // explicitly set the label, since we dont have a deepMerge method in this repo.
  return Object.assign({}, dataFromAPI, {
    dataSourceDefinition: Object.assign({}, dataFromAPI.dataSourceDefinition, {
      label
    })
  });
};
const mutateFetchedObjectDefinitionData = async (dataFromAPI, mutators) => {
  if (dataFromAPI.dataSourceDefinition.label) {
    return dataFromAPI;
  }
  const label = await makeFetchedObjectI18nLabel(dataFromAPI, mutators);

  // explicitly set the label, since we dont have a deepMerge method in this repo.
  return Object.assign({}, dataFromAPI, {
    dataSourceDefinition: Object.assign({}, dataFromAPI.dataSourceDefinition, {
      label
    })
  });
};
const mutateEnrolledObjectDefinitionData = async (dataFromAPI, mutators) => {
  if (dataFromAPI.dataSourceDefinition.name !== ENROLLED_OBJECT) {
    return dataFromAPI;
  }
  const label = await makeEnrolledObjectI18nLabel(dataFromAPI, mutators);

  // explicitly set the label, since we dont have a deepMerge method in this repo.
  return Object.assign({}, dataFromAPI, {
    dataSourceDefinition: Object.assign({}, dataFromAPI.dataSourceDefinition, {
      label
    })
  });
};
export const sourceDataMutate = async (dataFromAPI, mutators) => {
  const {
    dataSourceDefinition
  } = dataFromAPI;
  const {
    dataSourceType
  } = dataSourceDefinition;
  let revisedAPIData = Object.assign({}, dataFromAPI);
  try {
    switch (dataSourceType) {
      case DataSourceType.ACTION_OUTPUT:
        revisedAPIData = mutateActionOutputDefinitionData(dataFromAPI, mutators);
        break;
      case DataSourceType.FETCHED_OBJECT:
        revisedAPIData = await mutateFetchedObjectDefinitionData(dataFromAPI, mutators);
        break;
      case DataSourceType.CONTAINER:
        break;
      default:
        revisedAPIData = await mutateEnrolledObjectDefinitionData(revisedAPIData, mutators);
        break;
    }
  } catch (error) {
    console.error(error);
  }
  return revisedAPIData;
};